import { render, staticRenderFns } from "./ShapeEditor.vue?vue&type=template&id=25d21db3&scoped=true&"
import script from "./ShapeEditor.vue?vue&type=script&lang=js&"
export * from "./ShapeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ShapeEditor.vue?vue&type=style&index=0&id=25d21db3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d21db3",
  null
  
)

export default component.exports